<template>
  <i
    class="iconfont"
    :class="[props.icon, ...clzs]"
    :style="{ color: props.color }"
  ></i>
</template>

<script setup>
import { computed } from "vue";
const props = defineProps({
  icon: {
    type: String,
  },
  size: {
    type: String,
    default: "14",
  },
  color: {
    type: String,
    default: "#999",
  },
  bgStyle: {
    type: String,
    default: null,
  },
});

const clzs = computed(() => {
  return props.bgStyle ? ["bg-gradient", props.bgStyle] : [];
});
</script>

<style lang="scss" scoped>
.bg-gradient {
  color: transparent !important;
  background-clip: text !important;
  &.blue {
    background: linear-gradient(180deg, #7ee8ff, #2670ff);
  }
  &.purple {
    background: linear-gradient(180deg, #c4a7f4, #c065e0);
  }
  &.dark-purple {
    background: linear-gradient(180deg, #b9b0f4, #5654be);
  }
  &.yellow {
    background: linear-gradient(180deg, #f8e375, #fa9a29);
  }
  &.green {
    background: linear-gradient(180deg, #ccf772, #42bf5e);
  }
  &.red {
    background: linear-gradient(180deg, #ff7a00, #ff0f00);
  }
}
</style>
